<template>
  <!-- 机构班级编辑 -->
  <div>
    <el-dialog title="成员管理" :visible.sync="dialogVisible" width="30%">
      <div class="mode">
        <el-radio-group v-model="mode" @input="modeChange">
          <el-radio label="add">添加成员</el-radio>
          <el-radio label="del">删除成员</el-radio>
        </el-radio-group>
      </div>
      <el-form :inline="true">
        <el-form-item label="客服昵称">
          <el-input v-model="name" placeholder="客服昵称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="DataList"
        tooltip-effect="dark"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange"
      >
        <el-table-column :reserve-selection="true" type="selection" width="55">
        </el-table-column>
        <el-table-column label="头像">
          <template slot-scope="{ row }">
            <img :src="row.avatar" class="avatar" />
          </template>
        </el-table-column>
        <el-table-column prop="nick" label="昵称"> </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="changePage"
        :current-page.sync="currentpage"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="mode == 'add'" @click="addClassMember"
          >添加成员</el-button
        >
        <el-button type="primary" v-if="mode == 'del'" @click="delClassMember"
          >删除成员</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mode: "add",
      group: {},
      mecClass: {},
      allData: [],
      dialogVisible: false,
      DataList: [],
      studycard_id: "",
      changeList: [],
      total: 0,
      currentpage: 1,
      name: '',
    };
  },

  mounted() {},

  methods: {
    search() {
      this.currentpage = 1;
      this.getList();
    },
    reset() {
      this.$refs.multipleTable.clearSelection();
      this.total = this.allData.length;
      this.DataList = this.allData.slice(0, 10);
    },
    getRowKeys(row) {
      return row.id;
    },
    delClassMember() {
      let ids = this.changeList.map((item) => item.user_id);
      if (ids.length == 0) {
        this.$message("请选择成员");
        return;
      }
      this.$axios({
        url: "/chat/customerServiceGroup/delMember",
        method: "post",
        data: {
          group_id: this.group.id,
          memberIds: ids,
        },
      }).then((res) => {
        this.$refs.multipleTable.clearSelection();
        this.dialogVisible = false;
        this.$emit("success", res);
      });
    },
    addClassMember() {
      let ids = this.changeList.map((item) => item.user_id);
      if (ids.length == 0) {
        this.$message("请选择成员");
        return;
      }
      this.$axios({
        url: "/chat/customerServiceGroup/addMember",
        method: "post",
        data: {
          group_id: this.group.id,
          memberIds: ids,
        },
      }).then((res) => {
        this.$refs.multipleTable.clearSelection();
        this.dialogVisible = false;
        this.$emit("success", res);
      });
    },
    handleSelectionChange(val) {
      this.changeList = val;
    },
    load(row) {
      this.allData = [];
      this.DataList = [];
      this.mode = "add";
      this.group = row;
      this.dialogVisible = true;
      this.getList();
    },
    changePage(v) {
      this.currentpage = v;
      this.getList();
    },
    modeChange(v) {
      this.$refs.multipleTable.clearSelection();
      this.search();
    },
    //未分班成员
    getList() {
      let data = {
        currentPage: this.currentpage,
        pageSize: 10,
        role: 3,
        nick: this.name || null,
      };

      if (this.mode == "del") {
        data.group_id = this.group.id;
      } else {
        data.not_group_id = this.group.id;
      }
      this.$get("/chat/customerServiceGroup/queryUserList", data).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mode {
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
}
</style>